/* globals localStorage */

import React, { useState } from 'react';
import md5 from 'md5';
import {
  Login,
  minLength,
  PasswordInput,
  required,
  useNotify,
  useTranslate,
} from 'react-admin';
import { Form } from 'react-final-form';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { apiPut, apiPost } from '../brainApi';
import { sendToFullStory } from '../helper';

const useStyles = makeStyles(
  (theme) => ({
    form: {
      padding: '0 1em 1em 1em',
    },
    input: {
      width: '100%',
    },
    button: {
      width: '100%',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    backButton: {
      width: '100%',
      textAlign: 'center',
      fontSize: '0.75rem',
      marginTop: '2px',
      marginBottom: '8px',
    },
  }),
  { name: 'RaLoginForm' },
);

const ResetPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const classes = useStyles(props);
  const translate = useTranslate();
  const notify = useNotify();

  const { match } = props;
  const { params } = match;
  const { uuid } = params;

  const submit = ({ password, password2 }) => {
    if (password !== password2) {
      notify(translate('auth.passwords_do_not_match'), 'warning');
      return;
    }

    const payload = {
      rp_id: uuid,
      md5: md5(password),
    };

    setLoading(true);
    apiPut('/reset-password', payload, true).then((response) => {
      setLoading(false);
      if (response.Status === 'Success') {
        const { username } = response;
        if (response.is_admin) {
          notify(response.Message, 'info');
          apiPost('/admin-login', { email: username, md5: md5(password) })
            .then(({ token, user, employee }) => {
              if (token) {
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('employee', JSON.stringify(employee));
                localStorage.setItem('theme', 0);
                sendToFullStory(JSON.stringify(user));
                props.history.push('/');
                return Promise.resolve();
              }
              return Promise.reject();
            })
            .catch((error) => Promise.reject(error));
        } else {
          setMessage('Your password has been reset successfully!');
        }
      } else {
        notify(response.Message, 'warning');
        if (response.Message.includes('expired')) {
          props.history.push('/forgot-password');
        }
      }
    });
  };

  const form = (
    <Form
      onSubmit={submit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={classes.form}>
            <PasswordInput
              className={classes.input}
              source="password"
              label="auth.new_password_1"
              inputProps={{ autocomplete: 'new-password' }}
              validate={[required(), minLength(6)]}
            />
            <br />
            <PasswordInput
              className={classes.input}
              source="password2"
              label="auth.new_password_2"
              inputProps={{ autocomplete: 'new-password' }}
              validate={[required(), minLength(6)]}
            />
          </div>
          <CardActions>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              className={classes.button}
            >
              {loading && (
                <CircularProgress
                  className={classes.icon}
                  size={18}
                  thickness={2}
                />
              )}
              {translate('auth.set_new_password')}
            </Button>
          </CardActions>
        </form>
      )}
    />
  );

  return (
    <Login>
      {message ? <div className={classes.form}>{message}</div> : form}
      <div className={classes.backButton}>
        <a style={{ color: 'gray' }} href="/#/login">
          {translate('auth.back_to_login')}
        </a>
      </div>
    </Login>
  );
};

export default ResetPassword;
